module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel",
    class: _vm.panelType
  }, [_c('div', {
    staticClass: "panel-content-title"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "panel-content-body"
  }, [_vm._t("content")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-412ba810"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/panel.vue
// module id = 1401
// module chunks = 1